<acf>
  return component('centre-and-box', [
    'sub_fields' => [
      fragment_field(),
      text_field('heading'),
      text_field('box'),
      image_field('desktop_image'),
      image_field('mobile_image'),
      text_field('caption')
    ]
  ]);
</acf>

<php>
  return function ($content) {
    $content['field_CentreAndBox_mobile_image'] = get_svg_contents($content['field_CentreAndBox_mobile_image']);
    $content['field_CentreAndBox_desktop_image'] = get_svg_contents($content['field_CentreAndBox_desktop_image']);

    return $content;
  };
</php>

<script>
  export default {
    props: ['content']
  }
</script>

<template>
  <section class="section" :id="content.field_CentreAndBox_fragment_id">
    <div class="container">
      <div class="cube">
        <div class="square"><span>{{ content.field_CentreAndBox_box }}</span></div>
      </div>
      <div class="content">
        <h1>{{ content.field_CentreAndBox_heading }}</h1>
        <p>&nbsp;</p>
        <p class="is-hidden-mobile" v-html="content.field_CentreAndBox_desktop_image"></p>
        <p class="is-hidden-tablet" v-html="content.field_CentreAndBox_mobile_image"></p>
        <p>&nbsp;</p>
        <h4>{{ content.field_CentreAndBox_caption }}</h4>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .section {
    padding: 0.75rem 0 0 0;
    background: $blue;
    margin-top: 0.75em;
  }

  .content {
    padding: 1.5rem;
    text-align: center;
  }

  .content, .content h1, .content h4 {
    color: white;
  }


  .cube {
    background-image: url('../assets/cube.svg');
    width: 269px;
    height: 248px;
    font-size: 3rem;
    color: $pippin;
    font-family: 'Separat';
    margin-left: auto;
    margin-right: auto;
    position: relative;
    top: -130px;
  }

  html[lang=fr-FR] .cube, html[lang=de-DE] .cube, html[lang=fr-FR] .content /deep/ h1 {
    font-size: 2.5rem;
  }

  .cube .square {
    width: 208px;
    height: 210px;
    margin-left: auto;
    display: flex;
    align-items: center;
    line-height: 1.2;
    text-align: center;
  }

  @include desktop {
    .cube {
      position: absolute;
      right: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// components/CentreAndBox.vue